import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type SurveyGroupFilterInformation_SurveyGroupFiltersQuery as Data } from '~/gql/graphql'

import { useSurveyGroupFiltersQueryKey } from './useSurveyGroupFiltersQueryKey'

export const useSurveyGroupFiltersQueryData = () => {
  const queryKey = useSurveyGroupFiltersQueryKey()

  const { data } = useQuery<Data>({ enabled: false, queryKey })

  return React.useMemo(() => data?.surveyGroupFilters ?? [], [data])
}
